import Box from '@mui/material/Box'
import {useEffect, useState} from 'react'
import ApiService from '../../../common/ApiCalls'
import {Select, Text} from '../../1elements'
import {titleCase} from '../../../services/util/formatter'

const CountryDropDown = ({value, onChange, onEditMode}) => {
    const [options, setOptions] = useState([])

    useEffect(()=>{
        const extractCountryOptions = (allLandingOptions) => {
            const countryOptions = allLandingOptions.filter((option)=> option.is_country)
            countryOptions.forEach((country) => country.location_name = titleCase(country.location_name))
            return countryOptions.sort((a, b) => a.location_name.localeCompare(b.location_name))
        }

        const getCountryOptions = async () => {
            const allLandingOptions = await ApiService().getAllLandingOptions()
            setOptions(extractCountryOptions(allLandingOptions))
        }

        getCountryOptions()

    }, [])

    const selectValue = value
      ? options.find(option => option.location_name?.toLocaleLowerCase() === value.location_name?.toLocaleLowerCase())
      : ''

    return (
        <Box sx={{ maxWidth: '400px', minWidth: 150, position: 'relative' }}>
            <Text type={'h9'} style={{ position: 'absolute', top: -20 }}>Country</Text>
            <Select
              options={options}
              optionLabelKey={'location_name'}
              value={ selectValue ?? '' }
              onChange={onChange}
              helperText={'Select One'}
              disabled={!onEditMode}
            />
        </Box>
    )
}

export default CountryDropDown
